import { Component, Inject, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { APP_CONFIG } from '../../../app.config';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { ValidationService } from '../../../common/validation.service';
import { ValueListsService } from '../../../common/value-lists.service';
import { AppConfig } from '../../../models/config/app-config';
import { FormSubGroupControl } from '../../../models/formControls/FormSubGroupControl';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-referenz',
  templateUrl: './referenz.component.html',
  styleUrls: ['./referenz.component.scss']
})
export class ReferenzComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {

  private artSub: Subscription;

  private referenzListItemsSub: Subscription;

  referenzListItems: ValueListItem[];

  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              assistantPopoverService: AssistantPopoverService,
              @Inject(APP_CONFIG) public appConfig: AppConfig,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    // Initialize form
    this.form = fb.group({
      art: [null, validationService.getValidators('referenz.referenzArt')],
      einladendePerson_referenzPerson: new FormSubGroupControl(),
      einladendeOrganisation_Bildungseinrichtung: new FormSubGroupControl(),
      hotel: new FormSubGroupControl(),
      akkreditierterDiplomat: new FormSubGroupControl(),
      euBuerger: new FormSubGroupControl(),
      wohnungsInhaber: new FormSubGroupControl(),
      anmietungPrivat: new FormSubGroupControl(),
      anmietungGewerblich: new FormSubGroupControl()
    });
  }

  ngOnInit() {
    super.ngOnInit();

    this.referenzListItemsSub = this.valueListsService.getValueListItems('referenz_art')
    .subscribe((listItems: ValueListItem[]) => this.referenzListItems = listItems);

    this.artSub = this.form.controls.art.valueChanges.subscribe(newValue => {
      this.disableAllFormGroups();
      this.enableSelectedFormGroup(newValue);
    });
  }

  ngOnDestroy(): void {
    this.referenzListItemsSub.unsubscribe();
    this.artSub.unsubscribe();
  }

  disableAllFormGroups() {

    this.enableOrDisableControlWithTimeout(false, this.form.controls.einladendePerson_referenzPerson);
    this.enableOrDisableControlWithTimeout(false, this.form.controls.einladendeOrganisation_Bildungseinrichtung);
    this.enableOrDisableControlWithTimeout(false, this.form.controls.hotel);
    this.enableOrDisableControlWithTimeout(false, this.form.controls.akkreditierterDiplomat);
    this.enableOrDisableControlWithTimeout(false, this.form.controls.euBuerger);
    this.enableOrDisableControlWithTimeout(false, this.form.controls.wohnungsInhaber);
    this.enableOrDisableControlWithTimeout(false, this.form.controls.anmietungPrivat);
    this.enableOrDisableControlWithTimeout(false, this.form.controls.anmietungGewerblich);
  }

  enableSelectedFormGroup(value: string) {
    switch (+value) {
      case 2:
        this.enableOrDisableControlWithTimeout(true, this.form.controls.einladendePerson_referenzPerson);
        break;
      case 3:
        this.enableOrDisableControlWithTimeout(true, this.form.controls.einladendeOrganisation_Bildungseinrichtung);
        break;
      case 4:
        this.enableOrDisableControlWithTimeout(true, this.form.controls.hotel);
        break;
      case 5:
        this.enableOrDisableControlWithTimeout(true, this.form.controls.akkreditierterDiplomat);
        break;
      case 6:
        this.enableOrDisableControlWithTimeout(true, this.form.controls.euBuerger);
        break;
      case 7:
        this.enableOrDisableControlWithTimeout(true, this.form.controls.wohnungsInhaber);
        break;
      case 8:
        this.enableOrDisableControlWithTimeout(true, this.form.controls.anmietungGewerblich);
        break;
      case 9:
        this.enableOrDisableControlWithTimeout(true, this.form.controls.anmietungPrivat);
        break;
      default:
        break;
    }
  }
}

